import { Link } from 'react-router-dom';
import './Footer.css';

function VisaIcon() {
  return (
    <svg viewBox="0 0 48 32" aria-label="Visa" role="img">
      <rect width="48" height="32" rx="4" fill="#1A1F71" />
      <text x="8" y="21" fill="#fff" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="700" fontStyle="italic">
        VISA
      </text>
    </svg>
  );
}

function MastercardIcon() {
  return (
    <svg viewBox="0 0 48 32" aria-label="Mastercard" role="img">
      <rect width="48" height="32" rx="4" fill="#252525" />
      <circle cx="19" cy="16" r="8" fill="#EB001B" />
      <circle cx="29" cy="16" r="8" fill="#F79E1B" />
      <path d="M24 10.2a8 8 0 0 1 0 11.6 8 8 0 0 1 0-11.6z" fill="#FF5F00" />
    </svg>
  );
}

function AmexIcon() {
  return (
    <svg viewBox="0 0 48 32" aria-label="American Express" role="img">
      <rect width="48" height="32" rx="4" fill="#2E77BC" />
      <text x="6" y="20" fill="#fff" fontFamily="Arial, sans-serif" fontSize="8" fontWeight="700">
        AMEX
      </text>
    </svg>
  );
}

function DinersIcon() {
  return (
    <svg viewBox="0 0 48 32" aria-label="Diners Club" role="img">
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#D1D5DB" />
      <circle cx="24" cy="16" r="9" fill="#0079BE" />
      <circle cx="24" cy="16" r="6" fill="#fff" />
      <path d="M21 11v10c2.2 1.4 5.8 1.4 8 0V11c-2.2-1.4-5.8-1.4-8 0z" fill="#0079BE" />
    </svg>
  );
}

function DiscoverIcon() {
  return (
    <svg viewBox="0 0 48 32" aria-label="Discover" role="img">
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#D1D5DB" />
      <text x="5" y="14" fill="#1a1a1a" fontFamily="Arial, sans-serif" fontSize="6.5" fontWeight="700">
        Discover
      </text>
      <circle cx="36" cy="20" r="6" fill="#F47216" />
    </svg>
  );
}

function ApplePayIcon() {
  return (
    <svg viewBox="0 0 48 32" aria-label="Apple Pay" role="img">
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#D1D5DB" />
      <path
        fill="#111"
        d="M16.2 10.2c-.7.8-1.8 1.4-2.9 1.3-.1-1.1.4-2.3 1.1-3 .7-.8 1.9-1.4 2.9-1.4.1 1.2-.3 2.3-1.1 3.1zm1.1 1.5c-1.6-.1-3 .9-3.7.9s-1.9-.9-3.2-.8c-1.6.1-3.1 1-3.9 2.5-1.7 2.9-.4 7.2 1.2 9.6.8 1.2 1.7 2.4 3 2.4s1.7-.8 3.2-.8 1.9.8 3.2.8 2.1-1.1 2.9-2.3c.9-1.3 1.3-2.6 1.3-2.6s-2.5-1-2.5-3.8c0-2.4 1.9-3.5 2-3.6-1.1-1.6-2.8-1.8-3.5-1.8z"
      />
      <text x="22" y="20" fill="#111" fontFamily="Arial, sans-serif" fontSize="9" fontWeight="600">
        Pay
      </text>
    </svg>
  );
}

function GooglePayIcon() {
  return (
    <svg viewBox="0 0 48 32" aria-label="Google Pay" role="img">
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#D1D5DB" />
      <text x="7" y="20" fontFamily="Arial, sans-serif" fontSize="9" fontWeight="700">
        <tspan fill="#4285F4">G</tspan>
        <tspan fill="#5f6368">Pay</tspan>
      </text>
    </svg>
  );
}

function ShopPayIcon() {
  return (
    <svg viewBox="0 0 48 32" aria-label="Shop Pay" role="img">
      <rect width="48" height="32" rx="4" fill="#5A31F4" />
      <text x="8" y="20" fill="#fff" fontFamily="Arial, sans-serif" fontSize="10" fontWeight="700">
        shop
      </text>
    </svg>
  );
}

function KlarnaIcon() {
  return (
    <svg viewBox="0 0 48 32" aria-label="Klarna" role="img">
      <rect width="48" height="32" rx="4" fill="#FFB3C7" />
      <text x="6" y="20" fill="#0A0A0A" fontFamily="Arial, sans-serif" fontSize="8" fontWeight="700">
        Klarna
      </text>
    </svg>
  );
}

function MaestroIcon() {
  return (
    <svg viewBox="0 0 48 32" aria-label="Maestro" role="img">
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#D1D5DB" />
      <circle cx="19" cy="16" r="8" fill="#EB001B" />
      <circle cx="29" cy="16" r="8" fill="#00A2E5" />
    </svg>
  );
}

function UnionPayIcon() {
  return (
    <svg viewBox="0 0 48 32" aria-label="UnionPay" role="img">
      <rect width="48" height="32" rx="4" fill="#005B9A" />
      <rect x="8" y="8" width="10" height="16" rx="1" fill="#E21836" />
      <rect x="19" y="8" width="10" height="16" rx="1" fill="#00447C" />
      <rect x="30" y="8" width="10" height="16" rx="1" fill="#007B84" />
    </svg>
  );
}

const PAYMENTS = [
  VisaIcon,
  MastercardIcon,
  AmexIcon,
  DinersIcon,
  DiscoverIcon,
  ApplePayIcon,
  GooglePayIcon,
  ShopPayIcon,
  KlarnaIcon,
  MaestroIcon,
  UnionPayIcon,
];

const EXPLORE_LINKS = [
  { label: 'How It Works', to: '/how-it-works' },
  { label: 'For Households', to: '/for-households' },
  { label: 'For Business', to: '/for-business' },
  { label: 'Services', to: '/services' },
  { label: 'Post Scrap', to: '/post-scrap' },
  { label: 'Become a Collector', to: '/become-a-collector' },
  { label: 'FAQs', to: '/faqs' },
  { label: 'Contact', to: '/contact' },
];

const LINKS = [
  { label: 'Privacy policy', to: '/privacy-policy' },
  { label: 'Refund policy', to: '/refund-policy' },
  { label: 'Terms of service', to: '/terms-of-service' },
  { label: 'Cookie preferences', to: '/cookie-preferences' },
];

function InstagramIcon() {
  return (
    <svg viewBox="0 0 448 512" aria-hidden="true">
      <path
        fill="currentColor"
        d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
      />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg className="is-facebook" viewBox="0 0 320 512" aria-hidden="true">
      <path
        fill="currentColor"
        d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5 16.3 0 29.4.4 37 1.2V7.9C291.4 4 256.4 0 236.2 0 129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"
      />
    </svg>
  );
}

function TikTokIcon() {
  return (
    <svg className="is-tiktok" viewBox="0 0 448 512" aria-hidden="true">
      <path
        fill="currentColor"
        d="M448 209.91a210.06 210.06 0 0 1-122.77-39.25V349.38A162.55 162.55 0 1 1 185 188.31V278.2a74.62 74.62 0 1 0 52.23 71.18V0h88a121.18 121.18 0 0 0 1.86 22.17A122.18 122.18 0 0 0 381 102.39a121.43 121.43 0 0 0 67 20.14z"
      />
    </svg>
  );
}

const SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/scapscrap.app',
    Icon: InstagramIcon,
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/share/188sir2MG8/?mibextid=wwXIfr',
    Icon: FacebookIcon,
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@snapscrap.app',
    Icon: TikTokIcon,
  },
];

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <nav className="footer-explore" aria-label="Explore">
          {EXPLORE_LINKS.map((link) => (
            <Link key={link.label} to={link.to}>
              {link.label}
            </Link>
          ))}
        </nav>

        <nav className="footer-social" aria-label="Social media">
          {SOCIAL_LINKS.map(({ label, href, Icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
            >
              <Icon />
            </a>
          ))}
        </nav>

        <ul className="footer-payments" aria-label="Accepted payment methods">
          {PAYMENTS.map((Icon, index) => (
            <li key={index}>
              <Icon />
            </li>
          ))}
        </ul>

        <nav className="footer-meta" aria-label="Legal">
          <span>© 2026, SnapScrap</span>
          {LINKS.map((link) => (
            <Link key={link.label} to={link.to}>
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
